import { WeaTools } from 'ecCom';

export const checkTableFieldValueUnique = params => {
    return WeaTools.callApi('/api/integration/common1/checkTableFieldValueUnique', 'POST', params);
};
export const checkCasIsDeployed = params => {
  return WeaTools.callApi('/api/integration/common1/checkCasIsDeployed', 'POST', params);
};
export const checkValidateCode = params => {
  return WeaTools.callApi('/api/integration/common1/checkValidateCode', 'POST', params);
};


// WEBPACK FOOTER //
// ../src4js/pc4backstage/integration/apis/CommonService.js